export default __webpack_public_path__ + "static/media/7.ab1f077f.jpg";